import { useQuery } from '@tanstack/react-query';
import { Gift } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';

import { isReferralEligible, subscriptionMeOptions } from '@/entities/subscription';

type Props = {
    onClick: () => void;
};

export function ShareReferralLinkButton({ onClick }: Props) {
    const { data: subscription } = useQuery(subscriptionMeOptions());

    if (!isReferralEligible(subscription)) return null;

    return (
        <Button variant="ghost" onClick={onClick}>
            <Gift />
            Earn a free month
        </Button>
    );
}
